module.exports = require('./$.global');


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-core/~/core-js/modules/$.path.js
 ** module id = 479
 ** module chunks = 0 1 4 5 6 7 8
 **/